import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import { DeleteAPI } from "./../../libs/http-service/api/LearnLocal.api";
import { configureHeaders } from "../../libs/http-service/interceptors/http.interceptors";
// configureHeaders();

const useHooks = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const accountSendOtp = async (body) => {
    setLoading(true);
  
    try {
      const response = await DeleteAPI.accountSendOtp(body);
  
      if (response?.status === true) {
        toast.success(response.message || "OTP sent successfully!");
      } else {
        toast.error(response?.message || "Login failed. Please try again.");
      }
      return response;
    } catch (error) {
      toast.error("An error occurred.");
      return { status: false };
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (body) => {
    setLoading(true);
  
    try {
      const response = await DeleteAPI.verifyOtp(body);
  
      if (response?.status === true) {

        if (response?.data?.token) {
          localStorage.setItem("Token", response.data.token);
          const token = localStorage.getItem("Token")
          console.log(token)
        }
  
        toast.success(response.message || "OTP verified successfully!");
      } else {
        toast.error(response?.message || "OTP verification failed. Please try again.");
      }
  
      return response;
    } catch (error) {
      toast.error("An error occurred during OTP verification.");
      return { status: false };
    } finally {
      setLoading(false);
    }
  };

  const deleteAccountApi = async (body) => {
    // configureHeaders();
    setLoading(true);
  
    try {
       const Token = localStorage.getItem("Token");
      const response = await DeleteAPI.deleteAccountApi(body, Token);
  
      if (response?.status === true) {
        toast.success(response.message || "Account deleted successfully!");
      } else {
        toast.error(response?.message || "Account deletion failed.");
      }
  
      return response;
    } catch (error) {
      toast.error("An error occurred while deleting the account.");
      return { status: false };
    } finally {
      setLoading(false);
    }
  };
  


  
  
  return {
    accountSendOtp,
    verifyOtp,
    deleteAccountApi,
    loading,
  };
};

export default useHooks;
